var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoweye = function SvgShoweye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Zm0-3.334a2.336 2.336 0 0 0-2.333 2.333A2.336 2.336 0 0 0 8 10.333a2.336 2.336 0 0 0 2.334-2.334A2.336 2.336 0 0 0 8 5.666Zm.147 5.665c-2.871.067-4.744-2.389-5.365-3.335.684-1.07 2.407-3.26 5.072-3.328 2.86-.073 4.743 2.388 5.364 3.334-.683 1.07-2.407 3.261-5.071 3.33Zm6.432-3.663c-.426-.742-2.775-4.458-6.759-4.333-3.685.093-5.829 3.34-6.398 4.333a.666.666 0 0 0 0 .663c.42.731 2.686 4.335 6.595 4.335.054 0 .109 0 .164-.002 3.684-.094 5.828-3.34 6.398-4.333a.67.67 0 0 0 0-.663Z",
    fill: "#008545"
  })));
};
export default SvgShoweye;